import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";
export const unloadingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({
        createRawMaterial: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/receiving-data/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['rawMaterials', 'getAllSummary', 'ripeningSummary', 'pieChart', 'barChart','getUnloadingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Raw Material")
            },

        }),
        searchRawMaterial: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/receiving-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['rawMaterials',],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchUnloadingRawMaterial: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/receiving-data/unloading?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['rawMaterials',],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchWashingAreaRawMaterial: build.query({
            query: (data) => {

                let paramData = serialize(data);

                return {
                    url: `/receiving-data/washing-area?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['rawMaterials',],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        searchSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['summary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getRejectedLog: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/receiving-data/rejected-logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['rejectedLog'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getSuppliers: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/suppliers?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['suppliersList'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getFruits: build.query({
            query: () => {
                return {
                    url: `/fruits`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['fruitList'],
            async onQueryStarted(_, { queryFulfilled, }) {


                await handleQueryError(queryFulfilled)
            },
        }),
        getRawMaterialById: build.query({
            query: (id) => {
                return {
                    url: `/receiving-data/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['rawMaterialsById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateRawMaterial: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/receiving-data/update/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['rawMaterials', 'rawMaterialsById', 'getAllSummary', 'ripeningSummary', 'pieChart', 'barChart','getUnloadingSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Washing Data")
            },
        }),
        distributeRawMaterial: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/receiving-data/distribute/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['rawMaterials', 'rawMaterialsById', 'getAllSummary', 'ripeningSummary', 'pieChart', 'barChart','getUnloadingSummary','getWashingAreaSummary','getRejectionLogSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Washing Data")
            },
        }),
        updatePaidStatus: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/receiving-data/update/${id}/paid-status`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: [],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Washing Data")
            },
        }),
        generateBatchCode: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/receiving-data/generate-batchcode`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: [],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
});

export const {
    useCreateRawMaterialMutation,
    useSearchRawMaterialQuery,
    useSearchUnloadingRawMaterialQuery,
    useSearchWashingAreaRawMaterialQuery,
    useSearchSummaryQuery,
    useGetSuppliersQuery,
    useGetFruitsQuery,
    useUpdateRawMaterialMutation,
    useGetRawMaterialByIdQuery,
    useGetRejectedLogQuery,
    useDistributeRawMaterialMutation,
    useUpdatePaidStatusMutation,
    useGenerateBatchCodeMutation
} = unloadingApi;